// extracted by mini-css-extract-plugin
export default {"fontSize":"Footer_fontSize__Nq2zK"};